import { CoreError, TechnicalErrorIdentifier } from "./core-error";

export const enum CommonErrorModule {
    PATCHES = "Patches",
}

/**
 *  Error representing error about the state of a class / function
 *  - Inconsistent state / can't proceed
 */
export class IllegalStateError extends CoreError {}

/**
 *  Error reprensenting error about argument passed to a function / method
 *  - Missing argument
 *  - Invalid argument
 */
export class IllegalArgumentError extends CoreError {
    constructor(message?: string, argName?: string, expected?: string, got?: string) {
        let computedMessage = argName ? `argName : ${argName} ` : "";
        computedMessage += expected ? `expected : ${expected} ` : "";
        computedMessage += got ? `got : ${got} ` : "";
        computedMessage += message;

        super(computedMessage);
    }
}

/**
 *  Error representing error about methods or functions
 *  - Not implemented function / method
 *  - Not supported action
 */
export class UnsupportedOperationError extends CoreError {}

export class NotImplementedError extends CoreError {
    constructor(method: string, context: string) {
        super(`NotImplementedError: method ${method} in ${context}`);

        this.addContext("Archipad", { method: method });
        this.addContext("Archipad", { context: context });
    }
}

export class PatchError extends CoreError {
    public override identifier = new TechnicalErrorIdentifier(CommonErrorModule.PATCHES, "PATCH_ERROR");
}
